import { ColumnDef } from "@tanstack/react-table";
import { t } from "i18next";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../hooks/useFetch";
import { useScreenStore } from "../../../../stores/ScreenStore";
import { UsersTableData } from "../../../../types/formDataTypes";
import { UserCompact } from "../../../../types/types";
import { Button } from "../../../../ui/Button";
import { DataTable } from "../../../../ui/DataTable/DataTable";
import { ScrollArea } from "../../../../ui/ScrollArea/ScrollArea";

type Props = {
  updateMonitor: Function;
};

const ScreenUsersTab = ({updateMonitor}:Props) => {
  const {monitor} = useScreenStore();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState<UserCompact[]>();
  const [userRelationId, setUserRelationId] = useState<string>()

  const [{ response, isLoading, error }, doFetchItem] = useFetch(`/users`);
  const [{ response: saveResponse, isLoading: saveIsLoading, error: saveError }, doFetchItemSave] = useFetch(
    `/directories/screens/${monitor?.id}/user_relations`
  );

  const [{ response: deleteResponse, isLoading: deleteIsLoading, error: deleteError }, doFetchItemDelete] = useFetch(
    `/directories/screens/${monitor?.id}/user_relations/${userRelationId}`
  );

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    setUsers(response.data as unknown as UserCompact[]);
    setLoading(false);
  }, [response]);

  useEffect(() => {
    if (!saveResponse) return;
    updateMonitor()
  }, [saveResponse]);

  useEffect(() => {
    if (!deleteResponse) return;
    updateMonitor()
  }, [deleteResponse]);

  let nodes: UsersTableData[] = users?.map((data) => {
    return {
      id: data.id,
      first_name: data.attributes.first_name,
      last_name: data.attributes.last_name,
      middle_name: data.attributes.middle_name,
      email: data.attributes.email,
      status: data.attributes.status,
      division_id: data.attributes.division_id,
      person_id: data.attributes.personnel_id,
    };
  }) ?? [];

  nodes = _.sortBy(nodes, ["inventory_number"]);
  let data = { nodes };

  const connectUser = (id: string) => {
    doFetchItemSave({
      method: "POST",
      data: {
        data: {
          user_relation_id: id,
        },
      },
    });
  };

  const disconnectUser = (urId: string) => {
    setUserRelationId(urId)
    doFetchItemDelete({
      method: "DELETE",
    });
  };



  const columns: ColumnDef<UsersTableData>[] = [
    {
      header: t("surname"),
      cell: (props) => <div className="font-medium">{props.row.original.last_name}</div>,
    },
    {
      header: `${t("name")}`,
      cell: (props) => <div className="font-medium">{`${props.row.original.first_name}`}</div>,
    },
    {
      accessorKey: "id",
      header: "",
      cell: ({ row }) => (
        <div className="flex items-center gap-1 justify-end">
          {monitor?.attributes.user_relations.find((user) => String(user.user_relation.id) == row.original.id) ? (
            <Button
              variant="destructive"
              size="xs"
              onClick={() => {
                disconnectUser(
                  String(
                    monitor?.attributes.user_relations.find(
                      (user) => String(user.user_relation.id) == row.original.id
                    )?.id
                  )
                );
              }}
            >
              {t("disconnect")}
            </Button>
          ) : (
            <Button
              variant="default"
              size="xs"
              onClick={() => {
                connectUser(row.original.id);
              }}
            >
              {t("connect")}
            </Button>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="relative flex flex-col w-full h-full overflow-hidden bg-background px-6">
        <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
          <div className="flex flex-col space-y-1">
            <span className="text-2xl font-semibold">{t('choose_users_for_screen')}</span>
          </div>
        </div>
        <ScrollArea className="px-2">
          <DataTable data={data.nodes} columns={columns} />
        </ScrollArea>
      </div>
    </>
  );
};

export default ScreenUsersTab;
